import { AccountRangeMatcher } from '@app/application/report/account-range-matcher'

// Exposes AccountRangeMatcher on the global Silverfin.ReportEditor namespace so
// the deprecated CoffeeScript groups editor (sprockets pipeline) can instantiate
// it. The attach runs on dom load — after the sprockets bundle has created the
// namespace at eval time, and before the groups editor's own turbolinks:load
// handler uses the matcher: the webpack bundle is evaluated before the sprockets
// bundle, so this onDomLoad handler is bound first and therefore fires first.
export default (): void => {
  window.onDomLoad(() => {
    const namespace = (window.Silverfin.ReportEditor ??= {})
    namespace.AccountRangeMatcher = AccountRangeMatcher
  })
}
